// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import './App.css';

// import { AuthProvider } from './hooks/useAuth';
// import ProtectedRoute from './components/ProtectedRoute';

// import CanluxaAuth           from './pages/auth/CanluxaAuth';
// import OptionalServicesPage  from './pages/dashboards/OptionalServicesPage';
// import ResidentDashboard     from './pages/dashboards/ResidentDashboard';
// import ValetDashboard        from './pages/dashboards/ValetDashboard';
// import HOADashboard          from './pages/dashboards/HOADashboard';
// import SuperAdminDashboard   from './pages/dashboards/SuperAdminDashboard';
// import SuperAdminProperties  from './pages/dashboards/superadmin/SuperAdminProperties';
// import SuperAdminValetCodes  from './pages/dashboards/superadmin/SuperAdminValetCodes';
// import SuperAdminUsers       from './pages/dashboards/superadmin/SuperAdminUsers';
// import SuperAdminLogs        from './pages/dashboards/superadmin/SuperAdminLogs';
// import HOALogs               from './pages/dashboards/HOALogs';

// function App() {
//   return (
//     <AuthProvider>
//       <Router>
//         <Routes>
//           {/* Auth */}
//           <Route path="/" element={<CanluxaAuth />} />

//           {/* Resident */}
//           <Route path="/resident/dashboard" element={
//             <ProtectedRoute allowedRoles={['resident']}>
//               <ResidentDashboard />
//             </ProtectedRoute>
//           } />
//           <Route path="/resident/services" element={
//             <ProtectedRoute allowedRoles={['resident']}>
//               <OptionalServicesPage />
//             </ProtectedRoute>
//           } />

//           {/* Valet */}
//           <Route path="/valet/dashboard" element={
//             <ProtectedRoute allowedRoles={['valet']}>
//               <ValetDashboard />
//             </ProtectedRoute>
//           } />

//           {/* HOA */}
//           <Route path="/hoa/dashboard" element={
//             <ProtectedRoute allowedRoles={['hoa_admin']}>
//               <HOADashboard />
//             </ProtectedRoute>
//           } />
//           <Route path="/hoa/logs" element={
//             <ProtectedRoute allowedRoles={['hoa_admin']}>
//               <HOALogs />
//             </ProtectedRoute>
//           } />

//           {/* Super Admin */}
//           <Route path="/admin/dashboard" element={
//             <ProtectedRoute allowedRoles={['super_admin']}>
//               <SuperAdminDashboard />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/properties" element={
//             <ProtectedRoute allowedRoles={['super_admin']}>
//               <SuperAdminProperties />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/valet-codes" element={
//             <ProtectedRoute allowedRoles={['super_admin']}>
//               <SuperAdminValetCodes />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/users" element={
//             <ProtectedRoute allowedRoles={['super_admin']}>
//               <SuperAdminUsers />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/logs" element={
//             <ProtectedRoute allowedRoles={['super_admin']}>
//               <SuperAdminLogs />
//             </ProtectedRoute>
//           } />

//           {/* Fallback */}
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </Router>
//     </AuthProvider>
//   );
// }

// export default App;


import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import InstallPWA from './components/InstallPWA';

import CanluxaAuth           from './pages/auth/CanluxaAuth';
import OptionalServicesPage  from './pages/dashboards/OptionalServicesPage';
import ResidentDashboard     from './pages/dashboards/ResidentDashboard';
import ResidentMyTrash       from './pages/dashboards/ResidentMyTrash';
import ResidentHistory       from './pages/dashboards/ResidentHistory';
import ValetDashboard        from './pages/dashboards/ValetDashboard';
import ValetHistory          from './pages/dashboards/Valethistory';
import HOADashboard          from './pages/dashboards/HOADashboard';
import SuperAdminDashboard   from './pages/dashboards/SuperAdminDashboard';
import SuperAdminProperties  from './pages/dashboards/superadmin/SuperAdminProperties';
import SuperAdminValetCodes  from './pages/dashboards/superadmin/SuperAdminValetCodes';
import SuperAdminUsers       from './pages/dashboards/superadmin/SuperAdminUsers';
import SuperAdminLogs        from './pages/dashboards/superadmin/SuperAdminLogs';
import HOALogs               from './pages/dashboards/HOALogs';
import HOASubmissions        from './pages/dashboards/HOASubmissions';
import HOAValetStatus        from './pages/dashboards/HOAValetStatus';
import HOAReports            from './pages/dashboards/HOAReports';
import SplashScreen          from './components/SplashScreen';
import OfflineScreen from './components/OfflineScreen';
function App() {
  return (
    <AuthProvider>
      <SplashScreen />
      <OfflineScreen />
      <Router>
        <Routes>
          {/* Auth */}
          <Route path="/" element={<CanluxaAuth />} />

          {/* Resident */}
          <Route path="/resident/dashboard" element={
            <ProtectedRoute allowedRoles={['resident']}>
              <ResidentDashboard />
            </ProtectedRoute>
          } />
          <Route path="/resident/my-trash" element={
            <ProtectedRoute allowedRoles={['resident']}>
              <ResidentMyTrash />
            </ProtectedRoute>
          } />
          <Route path="/resident/history" element={
            <ProtectedRoute allowedRoles={['resident']}>
              <ResidentHistory />
            </ProtectedRoute>
          } />
          <Route path="/resident/services" element={
            <ProtectedRoute allowedRoles={['resident']}>
              <OptionalServicesPage />
            </ProtectedRoute>
          } />

          {/* Valet */}
          <Route path="/valet/dashboard" element={
            <ProtectedRoute allowedRoles={['valet']}>
              <ValetDashboard />
            </ProtectedRoute>
          } />
          <Route path="/valet/history" element={
            <ProtectedRoute allowedRoles={['valet']}>
              <ValetHistory />
            </ProtectedRoute>
          } />

          {/* HOA */}
          <Route path="/hoa/dashboard" element={
            <ProtectedRoute allowedRoles={['hoa_admin']}>
              <HOADashboard />
            </ProtectedRoute>
          } />
          <Route path="/hoa/logs" element={
            <ProtectedRoute allowedRoles={['hoa_admin']}>
              <HOALogs />
            </ProtectedRoute>
          } />
          <Route path="/hoa/submissions" element={
            <ProtectedRoute allowedRoles={['hoa_admin']}>
              <HOASubmissions />
            </ProtectedRoute>
          } />
          <Route path="/hoa/valet-status" element={
            <ProtectedRoute allowedRoles={['hoa_admin']}>
              <HOAValetStatus />
            </ProtectedRoute>
          } />
          <Route path="/hoa/reports" element={
            <ProtectedRoute allowedRoles={['hoa_admin']}>
              <HOAReports />
            </ProtectedRoute>
          } />

          {/* Super Admin */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SuperAdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/properties" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SuperAdminProperties />
            </ProtectedRoute>
          } />
          <Route path="/admin/valet-codes" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SuperAdminValetCodes />
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SuperAdminUsers />
            </ProtectedRoute>
          } />
          <Route path="/admin/logs" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SuperAdminLogs />
            </ProtectedRoute>
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <InstallPWA />
    </AuthProvider>
  );
}

export default App;